import { Link } from "react-router";

export default function Unauthorized() {
    return (
        <div className="text-center mt-10">
            <h1 className="text-2xl font-bold">Access Denied 🚫</h1>
            <p className="mt-2">You don’t have permission to view this page.</p>
            <Link to="/" className="text-blue-500 underline mt-4 block">
                Go back home
            </Link>
        </div>
    );
}
